import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  FormCheckResponse,
  ClientOnboardingFormType,
} from 'src/app/shared/models/dynamic-form.model';
import { OrgFormDisplayNameResponse } from 'src/app/shared/models/org-form-display-name.model';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(private httpClient: HttpClient) {}

  bmiCalculator(bmiData: any): Observable<any> {
    return this.httpClient.post('/api/users/bmi', bmiData).pipe((res) => res);
  }

  checkFreeDietEligibility(): Observable<any> {
    return this.httpClient.get('/api/users/check_free_diet_eligibility');
  }

  getOrganizationPages(): Observable<any> {
    return this.httpClient.get(`/api/organization/organization_pages`);
  }

  checkOnboardingFormByType(
    formType: ClientOnboardingFormType
  ): Observable<FormCheckResponse> {
    return this.httpClient.post<FormCheckResponse>(
      `/api/dynamicForms/check_onboarding_form`,
      { form_type: formType }
    );
  }

  checkHealthProgressForm(): Observable<any> {
    return this.httpClient.get(`/api/dynamicForms/check_health_progress_form`);
  }

  checkGeneralFeedbackForm(): Observable<FormCheckResponse> {
    return this.httpClient.get<FormCheckResponse>(
      `/api/dynamicForms/check_general_feedback_form`
    );
  }

  getOrgFormDisplayName(): Observable<OrgFormDisplayNameResponse> {
    return this.httpClient.get<OrgFormDisplayNameResponse>(
      `/api/dynamicForms/org_form_display_name`
    );
  }

  getBookmarks(): Observable<any> {
    return this.httpClient.get(`/api/organization/bookmark_urls`);
  }


   getYoutubeVideos(object: {page_number: number, page_size: number}):Observable<any>{
    return this.httpClient.post(`/api/organization/youtube_videos_list`, object);
  }

  checkClientReview(): Observable<any> {
    return this.httpClient.get(`/api/users/check_client_review`);
  }

  getPrimRating(): Observable<any> {
    return this.httpClient
      .get(`/api/users/get_prim_rating`)
      .pipe((res) => res);
  }

  updateReminderDate(reqObj): Observable<any> {
    return this.httpClient.post(
      `/api/users/update_reminder_date`,
      reqObj
    );
  }

  getCurrentExercisePlan(reqObj): Observable<any>{
    return this.httpClient.post(
      `/api/exercise/get_current_exercise_plan`,
      reqObj
    );
  }

  getExerciseLogs(): Observable<any> {
    return this.httpClient.post(
      `/api/exercise/get_exercise_logs`,
      {}
    );
  }

  submitExerciseLog(reqObj: any): Observable<any> {
    return this.httpClient.post(
      `/api/exercise/submit_exercise_log`,
      reqObj
    );
  }

  deleteExerciseLog(reqObj: any): Observable<any> {
    return this.httpClient.post(
      `/api/exercise/delete_exercise_log`,
      reqObj
    );
  }

  checkExerciseLog(reqObj: any): Observable<any> {
    return this.httpClient.post(
      `/api/exercise/check_exercise_log`,
      reqObj
    );
  }

  getExerciseCompliance(reqObj: any): Observable<any> {
    return this.httpClient.post(
      `/api/exercise/get_exercise_compliance`,
      reqObj
    );
  }

  getClientHealthProgressPdf(): Observable<any> {
    return this.httpClient.get(`/api/DynamicForms/latest_client_health_report_pdf`);
  }

   getClientFormDetails(reqObj: any): Observable<any> {
    return this.httpClient.post(`/api/DynamicForms/form_details_client_id`, reqObj);
  }



}
